import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ConnectedUser } from '../../connection/socket';
import Avatar from '../general-components/avatar';
import Icon, { ICONS, COLORS } from '../general-components/icon';
import * as Utils from '../../utils/utils';
import useProfile from '../../hooks/use-profile';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../../stores/types/types';

enum CHAT {
	MAIN = 1,
	ROOM = 2
}

interface OwnProps {
	style: number
	user: ConnectedUser,
	roomUsers?: ConnectedUser[]
	callback?: (u: ConnectedUser) => void
}

export default function InviteBadge(props: OwnProps) {
	const {user, roomUsers, callback, style} = props;
	const useMasks = useSelector((state: GreenroomState) => state.SettingsReducer.featureFlags.use_profile_masks);

	const highlight = useMemo(() => roomUsers?.some(
		(_user: ConnectedUser) => _user.gr_user === user.gr_user,
	), [roomUsers, user.gr_user]);

	const {watchedProfile} = useProfile({suggestedProfile: user.gr_user})
	const profile = (useMasks && watchedProfile) ? watchedProfile : user;

	return (<>
		<div 
			className={classNames(
				`invite-badge ${style === CHAT.ROOM ? 'button invite-badge background-dark margin-right-small margin-top-small' : ''}`, 
				{ selected: highlight && style === CHAT.MAIN },
			)}
			onClick={() => callback?.(user)}
		>
			<Avatar user={profile} size={'xsmall'} noBorder={true} />
			<span className={classNames({'margin-right-small': style === CHAT.ROOM})}>
				{Utils.getNameOrInitials(profile, true)}
			</span>
			{style === CHAT.ROOM ? null
				: <div className={classNames('add-close-button', highlight ? 'close-btn' : '')}>
					<Icon size={16} name={ICONS.ADD_CLOSE_CIRCLE} color={highlight ? COLORS.WHITE : COLORS.GRAY}/>
				</div>}
		</div>
	</>);
}
